import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { TooltipDirective } from 'Shared/app/directives/wfs-tooltip.directive';

@Component({
  selector: 'wfs-form-button',
  templateUrl: './form-button.component.html',
  styleUrls: ['./form-button.component.scss'],
  imports: [CommonModule, TooltipDirective]
})
export class FormButtonComponent {
  label = input('');
  ariaLabel = input<string | undefined>(undefined); //Template uses label() if undefined
  icon = input(''); // Input classes for fa-icons (also spacing classes for the icon, see the HTML)
  disabled = input(false);
  buttonStyle = input<ButtonStyle>(); // Applies corresponding classes to the button
  buttonTooltip = input<string | undefined>(undefined); // Tooltip text (only shows if defined)
  tooltipDelay = input<number>(100); // Sets delay for tooltip to show in milliseconds
  bringToFront = input(false); // Sets Z-index to 1
  overrideButtonMinWidth = input(false); // Sets min-width to 0px
  overrideButtonWidth = input(false); // Sets width to 100%
  overrideFontSize = input(false); // Sets font-size to 0.8rem
  shouldBlurAfterClick = input(false); // Sets blur to true after click

  // TODO: Stylingfixes
  // TODO: Check environment to apply (old) specific styles depending on if patient or careprovider.
  // Styles are prepped from old, using careprovider by default
  appEnvironment = input<'patient' | 'careprovider'>('careprovider');

  buttonClicked = output<void>();

  readonly buttonClasses = computed(() => ({
    'btn-primary': this.buttonStyle() === 'primary',
    'btn-secondary': this.buttonStyle() === 'secondary',
    'btn-success': this.buttonStyle() === 'success',
    'btn-danger': this.buttonStyle() === 'danger',
    'btn-warning': this.buttonStyle() === 'warning',
    'btn-info': this.buttonStyle() === 'info',
    'btn-light': this.buttonStyle() === 'light',
    'btn-primary-clear': this.buttonStyle() === 'primary-clear',
    'btn-clear': this.buttonStyle() === 'clear',
    'btn-add': this.buttonStyle() === 'add',
    'btn-close': this.buttonStyle() === 'close',
    'btn-shared-variant': this.appEnvironment() === 'careprovider',
    'btn-form-variant': this.appEnvironment() === 'patient',
    'btn-primary-shared-variant': this.appEnvironment() === 'careprovider',
    'btn-primary-form-variant': this.appEnvironment() === 'patient',
    'btn-secondary-shared-variant': this.appEnvironment() === 'careprovider',
    'btn-secondary-form-variant': this.appEnvironment() === 'patient',
    'font-size-8': this.overrideFontSize(),
    'bring-to-front': this.bringToFront(),
    'min-width-110': !this.overrideButtonMinWidth(),
    'min-width-0': this.overrideButtonMinWidth(),
    'width-100': this.overrideButtonWidth()
  }));

  onClick(buttonElement: HTMLButtonElement) {
    if (!this.disabled()) {
      this.buttonClicked.emit();
      if (this.shouldBlurAfterClick()) {
        buttonElement.blur();
      }
    }
  }
}

/** btn-styles with style overrides that can be applied */
export type ButtonStyle =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'light'
  | 'clear'
  | 'primary-clear'
  | 'add'
  | 'close';
